import { render, staticRenderFns } from "./server_list.vue?vue&type=template&id=20b0378f&"
import script from "./server_list.vue?vue&type=script&lang=js&"
export * from "./server_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports